import React from 'react';
import PropTypes from 'prop-types';
import {Box, Button, Flex, Text} from 'rebass'
import {Backdrop, Block, Overlay, styled} from "reakit";

const ConfirmDelete = props => {
	const {visible, handleConfirm} = props;
	const NewBackdrop = styled(Backdrop)`
		z-index: 9999 !important;
	`
	return (
		<Overlay.Container>
			{overlay => (
				<Block>
					{/*<Button use={Overlay.Show} {...overlay}>Click me</Button>*/}
					<NewBackdrop fade use={Overlay.Hide} {...overlay} visible={visible}/>
					<Overlay fade slide {...overlay} visible={visible} width={'80vw'}>
						<Flex flexDirection={'column'} justifyContent={'space-between'}>
							<Box>
								<Text textAlign={'center'}>Are you sure you'd like to delete this?</Text>
							</Box>
							<Flex justifyContent={'center'}>
								<Button variant={'second'} p={1} m={1} bg='red' onClick={handleConfirm}>Delete</Button>

								<Button variant={'second'} p={1} m={1} bg={'green'} onClick={props.toggle}>Cancel</Button>
							</Flex>

						</Flex>

					</Overlay>
				</Block>
			)}
		</Overlay.Container>
	);
};

ConfirmDelete.propTypes = {
	handleConfirm: PropTypes.func,
	toggle: PropTypes.func,
	visible: PropTypes.bool
};

ConfirmDelete.defaultProps = {
	handleConfirm: () => console.log('clicked confirm delete'),
	visible: false
};

export default ConfirmDelete;
